
<app-sidenav></app-sidenav>
<div class="background-container" >
  <div class="">
    <app-chat-layout [functionList]="functionList" [methodSelected]="chatPayload" [chatData]="chatData" [isReset]="resetChatStatus" (apiCall)="getResponse($event)"></app-chat-layout>
    <!-- <app-newchat-layout [functionList]="functionList" [methodSelected]="chatPayload" [chatData]="chatData" [isReset]="resetChatStatus" (apiCall)="getResponse($event)"></app-newchat-layout> -->
  </div>
</div>

